// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"105":"d65a6a463da49411","340":"74516fdc9a886f5f"}[chunkId] + ".js";
};